module.exports = function(element) {
  function rotateBlock(el) {
    var node       = $(el)
    var url        = node.data('url')
    var resolution = node.data('resolution')

    var resolution_arr = resolution.split("x")

    node.on({click: function() {
        location = url.replace('111x111', resolution_arr[1] + 'x' + resolution_arr[0])
    }})
  }

  if (!element) {
    throw new Error('Element undefined');
  }

  rotateBlock(element);
};
